import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, combineLatest, of, throwError } from 'rxjs';
import { map, catchError, mergeMap, startWith } from 'rxjs/operators';
import { VSpecService } from '../../../services/api/vspec.service';
import { VSpecDetailService } from '../detail/v-spec-detail.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadPDFResolver implements Resolve<any> {

  constructor(
    public vSpecService: VSpecService,
    public vSpecDetailService: VSpecDetailService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<any> {
    const vin = route.parent.paramMap.get('vin');
    const dealerCd = route.parent.paramMap.get('dealerCd');
    const hashValue = route.queryParamMap.get('k');
    const shouldBeDownloaded = route.url.filter(u => u.path === 'download').length > 0;
    const novin = route.url.filter(u => u.path === 'novin').length > 0;
    return this.getVehicleDetails(vin, dealerCd, hashValue, shouldBeDownloaded,novin);
  }

  getVehicleDetails(vin: string, dealerCd: string, hashValue: string, shouldBeDownloaded: boolean,novin: boolean): Observable<any> {
    return combineLatest([
      this.vSpecService.getVehicleDetails(vin, dealerCd, hashValue),
      this.vSpecDetailService.getDealerDetails$(dealerCd),
      this.vSpecDetailService.isSmartPathDealer$(dealerCd)
    ]).pipe(
      map(([vehicleData, dealerData, isSmartPathDealer]) => {
        const vehicleDataProcessed = this.vSpecDetailService.processCriticalData(vehicleData);
        const vData = this.vSpecDetailService.processData(vehicleDataProcessed, isSmartPathDealer);
        vData.dealerDetails = dealerData;
        vData.isSmartPathDealer = isSmartPathDealer;

        const args: any = {
          year: vData.vehicleDetails.year,
          series: vData.vehicleDetails.marketingSeries,
          distributorCd: vData.vehicleDetails.distributorCd,
        };

        return {
          vData,
          args
        }
      }),
      mergeMap(({ vData, args }) => {
        return combineLatest([
          of(vData),
          this.vSpecDetailService.getDisclaimers(args, vData.isSmartPathDealer)
            .pipe(
              // startWith(null),
              catchError(err => of(null))
            )
          ])
        }
      ),
      map(([vData, disclaimerData]) => {
        if (disclaimerData) {
          if (vData.isSmartPathDealer) {
            vData.baseMsrpDisclaimer = disclaimerData.description;
          } else {
            vData.baseMsrpDisclaimer = disclaimerData.baseMsrpDisclaimer.description;
            vData.tsrpDisclaimer = disclaimerData.tsrpDisclaimer.description;
          }
        }
        if (shouldBeDownloaded) {
          this.vSpecDetailService.downloadVSpecPDF(vData.baseMsrpDisclaimer, vData.tsrpDisclaimer ,novin);
        }

        return vData;
      }),
      catchError(err => {
        return of(null);
      })
    );
  }

}
